import { NavigationDataStore } from '@store/modules/navigation';
import {
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    ComputedRef,
} from '@vue/composition-api';
import {
    ContextNavigationItem,
    NavigationContextProps,
    SuperbetRouteConfig,
} from '@superbet-group/web.types';

export function useMobileHeaderData() {
    const { route } = useVueRouter();
    const superbetRoute = route as ComputedRef<SuperbetRouteConfig>;
    const navigationModule = useVuexStore<NavigationDataStore>('navigation');

    return {
        title: computed(() => superbetRoute.value.meta?.headerTitle ?? ''),
        isTopLevelRoute: computed(() => isTopLevelRoute(superbetRoute, navigationModule.getter('currentTopLevelNavigation'))),
        isHome: computed(() => superbetRoute.value.meta?.mobileHeaderConfig?.isHome ?? false),
        isContracted: computed(() => superbetRoute.value.meta?.mobileHeaderConfig?.isContracted ?? false),
        headerActionItems: computed(() => {
            const routeActionItems = navigationModule.getter('mobileRouteActionItems');
            return routeActionItems.value[superbetRoute.value.name!] ?? [];
        }),
    };
}

function isTopLevelRoute(route: ComputedRef<SuperbetRouteConfig>, currentNavigationContext: ComputedRef<NavigationContextProps | undefined>): boolean {
    const routeProp = route.value.meta?.mobileHeaderConfig?.isTopLevelRoute ?? route.value.meta?.isTopLevelRoute;
    if (routeProp !== undefined) {
        return routeProp;
    }
    return !!currentNavigationContext.value && currentNavigationContext.value.mobileItems
        .map((item: ContextNavigationItem) => item.destination.location.name)
        .includes(route.value.name ?? undefined);
}
